function Sensor({
  _id,
  sensor_id,
  sensor_name,
  room_id,
  sensor_type,
  status,
  update_time,
  building_id,
  building_name,
}) {
  this.id = _id;
  this.sensorId = sensor_id;
  this.sensorName = sensor_name;
  this.roomId = room_id;
  this.sensorType = sensor_type;
  this.status = status;
  this.updateTime = update_time;
  this.buildingId = building_id;
  this.buildingName = building_name;
}

export default Sensor;
